import { render, staticRenderFns } from "./OptometryPendingTable.vue?vue&type=template&id=2ce6a022&"
import script from "./OptometryPendingTable.vue?vue&type=script&lang=js&"
export * from "./OptometryPendingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports